import React, { useEffect, useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { auth } from "../../api";
import ImageViewer from "../../components/ImageViewer";
function ROIPublic() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const context = useContext(AppSettings);
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    machineOutput: "",
    machinesInOperation: "",
    manHoursReplacement: "",
    hoursTesting: "",
    leadTimeReplacement: "",
    costOfProduction: "",
    manpowerRequired: "",
    manpowerCost: "",
    maintenanceSystem: "24/7",
    maintenanceSystemOther: "",
    costReplacingMachine: "",
    annualPreventiveMaintenance: "",
    costMaintenanceActivity: 100,
    manHoursMaintenance: 2,
  });
  const [results, setResults] = useState({
    unplannedDowntime: 0,
    manHourSaved: 0,
    costSaved: 0,
    estimatedROI: 0,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = React.useState(false);

  //forgot

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);
  const tooltip = (word) => (
    <Tooltip id="tooltip">
      <strong>{word}</strong>
    </Tooltip>
  );

  async function handleSubmit(event) {
    event.preventDefault();

    const downtimeBefore =
      parseInt(inputs.leadTimeReplacement) +
      parseInt(inputs.hoursTesting) +
      parseInt(inputs.manHoursReplacement);
    const targetResolution = 0.85;
    const targetResolutionManPower = 0.8;
    const downtimeAfter = downtimeBefore * (1 - targetResolution);
    const numbRepairBefore = downtimeBefore;
    const numbRepairAfter = numbRepairBefore * (1 - targetResolutionManPower);
    const unplannedDowntime =
      inputs.machineOutput * downtimeBefore * inputs.costOfProduction;
    const unplannedDowntimeAfter =
      inputs.machineOutput * downtimeAfter * inputs.costOfProduction;
    const maintenanceCost =
      numbRepairBefore * inputs.manpowerCost * inputs.manpowerRequired;
    const maintenanceCostAfter =
      numbRepairAfter * inputs.manpowerCost * inputs.manpowerRequired;
    const manHourSaved =
      numbRepairBefore * inputs.manpowerCost * inputs.manpowerRequired;

    const costSaved =
      parseFloat(inputs.costReplacingMachine) +
      inputs.manHoursReplacement *
        inputs.manpowerCost *
        inputs.manpowerRequired -
      (inputs.costMaintenanceActivity +
        inputs.manHoursMaintenance * inputs.manpowerCost);

    const MachineMaintenanceCostAfter =
      parseFloat(inputs.costMaintenanceActivity) +
      inputs.manHoursMaintenance * inputs.manpowerCost;
    const totalInvestment = 8000;

    const TotalSavingAfter =
      unplannedDowntime -
      unplannedDowntimeAfter +
      (maintenanceCost - maintenanceCostAfter) -
      MachineMaintenanceCostAfter;

    const estimatedROI =
      ((TotalSavingAfter - totalInvestment) / totalInvestment) * 100;

    try {
      //setLoading(true);
      const response = await auth.submit_roi(inputs);
      setLoading(false);
      if (response.ok) {
        const body = await response.json();

        if (body.success) {
          //toast.success(body.message);
          toast.success("Please check your email");
          setOpen(false);
        } else {
          toast.error("Email not found");
        }
      } else {
        const body = await response.json();

        let message = body.message;

        toast.error(message);
      }
    } catch (e) {
      toast.error(e);
      setLoading(false);
    }

    setResults({
      unplannedDowntime,
      manHourSaved,
      costSaved,
      estimatedROI: estimatedROI.toFixed(2),
    });
    setSubmitted(true);
  }
  return (
    <div className="login" style={{ background: "#061929" }}>
      <LoadingIndicator open={loading} />
      <div style={{ width: "100%", padding: "0 50px" }}>
        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div className="my-1 text-center">
              <h2>ROI Calculation Tool</h2>
            </div>
            <div className="text-inverse text-opacity-50 text-center mb-4">
              See how Groundup.ai can maximize your savings.
            </div>
            <div className="row">
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Specify the number of units produced by the machine per hour."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Machine Output per Hour (unit/hour){" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="machineOutput"
                  value={inputs.machineOutput}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Total number of machines currently in use."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Number of Machines in Operation{" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="machinesInOperation"
                  value={inputs.machinesInOperation}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Total man-hours required to replace parts or machinery."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    No. of Man-Hours for Replacement (hour){" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="manHoursReplacement"
                  value={inputs.manHoursReplacement}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Number of hours needed for testing after replacement."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    No. of Hours for Testing (hour){" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="hoursTesting"
                  value={inputs.hoursTesting}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Time (in hours) needed to acquire replacement parts."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Lead Time for Replacement Parts (hour){" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="leadTimeReplacement"
                  value={inputs.leadTimeReplacement}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Time (in hours) needed to acquire replacement parts."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Hourly production cost for each machine.{" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="costOfProduction"
                  value={inputs.costOfProduction}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Time (in hours) needed to acquire replacement parts."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Number of workers needed for maintenance or replacement
                    tasks. <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="manpowerRequired"
                  value={inputs.manpowerRequired}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip("Hourly wage or cost per worker.")}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Manpower Cost per Hour ($){" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="manpowerCost"
                  value={inputs.manpowerCost}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Operating hours for your maintenance system (e.g., 24/7, 12 hours, 9 hours)."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    How does your maintenance system work?{" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <select
                  name="maintenanceSystem"
                  value={inputs.maintenanceSystem}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                >
                  <option value="24/7">24/7</option>
                  <option value="12 Hours">12 Hours</option>
                  <option value="9 Hours">9 Hours</option>
                  <option value="Other">
                    Other (if other, please specific)
                  </option>
                </select>
              </div>
              {inputs.maintenanceSystem === "Other" ? (
                <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip(
                      "Operating hours for your maintenance system (e.g., 24/7, 12 hours, 9 hours)."
                    )}
                  >
                    <label className="form-label" style={{ minHeight: "42px" }}>
                      Other maintenance system work?{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="text"
                    name="maintenanceSystemOther"
                    value={inputs.maintenanceSystemOther}
                    onChange={handleChange}
                    required={true}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder=""
                  />
                </div>
              ) : null}

              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip("Full replacement cost of the machine.")}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Cost of Replacing Machine{" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="costReplacingMachine"
                  value={inputs.costReplacingMachine}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={tooltip(
                    "Total annual cost dedicated to preventive maintenance for this asset."
                  )}
                >
                  <label className="form-label" style={{ minHeight: "42px" }}>
                    Annual Cost of Preventive Maintenance{" "}
                    <span className="text-danger">*</span>
                  </label>
                </OverlayTrigger>

                <input
                  type="number"
                  name="annualPreventiveMaintenance"
                  value={inputs.annualPreventiveMaintenance}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
            </div>
            <hr />
            <div></div>
            <div className="row">
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={inputs.name}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <label className="form-label">
                  Work Email<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="email"
                  value={inputs.email}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <label className="form-label">
                  Phone<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="phone"
                  value={inputs.phone}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
              <div className="mb-5 col-lg-4 col-md-4 col-sm-6 col-12">
                <label className="form-label">
                  Company<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="company"
                  value={inputs.company}
                  onChange={handleChange}
                  required={true}
                  className="form-control form-control-lg bg-white bg-opacity-5"
                  placeholder=""
                />
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                type="submit"
                disabled={loading}
                className="iframe-button"
              >
                Calculate ROI
              </button>
            </div>
          </form>
        ) : (
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Submit Success
            </CardHeader>
            <CardBody>
              <div>
                <h4>
                  Thank you for your submission! We’ll review it and send you
                  the results within the next 24 hours.
                </h4>
              </div>
              {/*<div>*/}
              {/*  <h3>Here is the Result {inputs.name}</h3>*/}
              {/*  <table style={{ fontSize: "16px" }}>*/}
              {/*    <tbody>*/}
              {/*      <tr>*/}
              {/*        <td>Unplanned Downtime</td>*/}
              {/*        <td>:</td>*/}
              {/*        <td>*/}
              {/*          <b>${results.unplannedDowntime}</b>*/}
              {/*        </td>*/}
              {/*      </tr>*/}
              {/*      <tr>*/}
              {/*        <td>Man Hour Saved</td>*/}
              {/*        <td>:</td>*/}
              {/*        <td>*/}
              {/*          <b>{results.manHourSaved} hours</b>*/}
              {/*        </td>*/}
              {/*      </tr>*/}
              {/*      <tr>*/}
              {/*        <td>Cost Saved</td>*/}
              {/*        <td>:</td>*/}
              {/*        <td>*/}
              {/*          <b>${results.costSaved}</b>*/}
              {/*        </td>*/}
              {/*      </tr>*/}
              {/*      <tr>*/}
              {/*        <td>Estimated ROI</td>*/}
              {/*        <td>:</td>*/}
              {/*        <td>*/}
              {/*          <b>{results.estimatedROI}%</b>*/}
              {/*        </td>*/}
              {/*      </tr>*/}
              {/*    </tbody>*/}
              {/*  </table>*/}
              {/*</div>*/}
            </CardBody>
          </Card>
        )}
      </div>
    </div>
  );
}

export default ROIPublic;
